import Vue from 'vue';
import store from 'jystore/store';
import App from './index.vue';

// vant -- start
import VueTouch from "vue-touch";
/* eslint-disable */
import {
  Form, Empty, NumberKeyboard,
  Loading, Tabbar, TabbarItem, NavBar, Icon, Image, PullRefresh, Lazyload, Search, Tab, Tabs, Button, List, Row, CellGroup, Cell, Col,
  Grid, GridItem, Divider, DropdownMenu, DropdownItem, Panel, DatetimePicker, Steps, Step, ActionSheet, Picker, RadioGroup, Radio,
  Swipe, SwipeItem, CountDown, Overlay, Skeleton, IndexBar, IndexAnchor, Collapse, CollapseItem, Uploader, ImagePreview,
  Field, Tag, Sticky, SubmitBar, Card, Checkbox, CheckboxGroup, Stepper, Dialog, Notify, NoticeBar,
  Toast, Popup, Sku, CouponList, CouponCell, AddressEdit, AddressList,
  GoodsAction,
  GoodsActionIcon,
  GoodsActionButton
} from "vant";

import VueLazyload from 'vue-lazyload';
Vue.use(VueLazyload);

Vue.use(VueTouch, { name: 'v-touch' });
Vue.use(Form);
Vue.use(Empty);
Vue.use(NumberKeyboard);
Vue.use(Loading);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(NavBar);
Vue.use(Icon);
Vue.use(Image);
Vue.use(Lazyload);
Vue.use(PullRefresh);
Vue.use(Search);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Button);
Vue.use(List);
Vue.use(Row);
Vue.use(CellGroup);
Vue.use(Cell);
Vue.use(Col);
Vue.use(Grid);
Vue.use(GridItem);
Vue.use(Divider);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Panel);
Vue.use(DatetimePicker);
Vue.use(Steps);
Vue.use(Step);
Vue.use(ActionSheet);
Vue.use(Picker);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(CountDown);
Vue.use(Overlay);
Vue.use(Skeleton);
Vue.use(IndexBar);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Uploader);
Vue.use(ImagePreview);
Vue.use(IndexAnchor);
Vue.use(Field);
Vue.use(Tag);
Vue.use(Sticky);
Vue.use(SubmitBar);
Vue.use(Card);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Stepper);
Vue.use(Sku);
Vue.use(NoticeBar);
Vue.use(Popup);
Vue.use(Dialog);
Vue.use(CouponList);
Vue.use(CouponCell);
Vue.use(AddressEdit);
Vue.use(AddressList);
Vue.use(GoodsAction);
Vue.use(GoodsActionIcon);
Vue.use(GoodsActionButton);
Vue.prototype.Toast = Toast;
Vue.prototype.Dialog = Dialog;
Vue.prototype.Notify = Notify;
Vue.prototype.$message = Notify;

import 'nprogress/nprogress.css';

// 路由表
import router from 'jyrouter/router-web';

// vue相关配置
import '../config';
import { urlConfig } from '../config';

// 4. 创建和挂载根实例。
// 记得要通过 router 配置参数注入路由，
// 从而让整个应用都有路由功能
let _vue = new Vue({
  /*el: '#app',*/
  store: store,
  render: h => h(App),
  router
});

urlConfig(() => {
  _vue.$mount('#app');
});

// 现在，应用已经启动了！
